import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { getSeoUrls } from '../api/get_seo_urls';
import { COMMON_VILLAGES_PATH } from '../constants';
import { IReduxThunkContext } from '../types/store';
import { generateQueryString } from './filters';

export function getCommonVillagesPath(filters: IGetVillageListRequestSchema) {
  const qs = generateQueryString(filters, false, true);

  return qs ? `${COMMON_VILLAGES_PATH}?${qs}` : COMMON_VILLAGES_PATH;
}

export async function getSeoUrlPath(
  context: IReduxThunkContext,
  rawPath: string,
  filters: IGetVillageListRequestSchema,
  addFiltersState: boolean = false,
) {
  const qs = generateQueryString(filters, false);
  if (!addFiltersState) {
    const seoUrl = await getSeoUrls(context.httpApi, context.logger, { query: qs, subdomain: context.subdomain });

    return seoUrl || getCommonVillagesPath(filters);
  }

  return qs ? `${rawPath}?${qs}&filters=opened` : rawPath;
}
